import React from 'react';
import groupBy from 'lodash/groupBy';

import TreeView from '../Treeview/TreeView';
import HeaderComponent from './TaxonomyNodeHeader';

const formatTaxonomyData = (terms = []) => {
  try {
    let formattedTerms: any = [];

    if (terms.length) {
      let groupedObject = groupBy(terms, (data) => {
        const { ancestors = [] } = data;
        return ancestors[0]?.name;
      });
      Object.keys(groupedObject).map((groupKey) => {
        const taxonomyGroupObject = {
          name: groupKey,
          group: true,
          search: true
        };
        formattedTerms.push(taxonomyGroupObject);
        const groupValue = groupedObject[groupKey];

        groupValue.forEach((term) => {
          const { ancestors = [] } = term;

          let ancestorsArray = ancestors.map((ancestor) => ancestor.name);
          ancestorsArray.push(term.name);
          let pathString = ancestorsArray.join(' / ');

          formattedTerms.push({
            path: pathString,
            name: term.name,
            uid: term.uid,
            taxonomyUid: term.taxonomy_uid,
            search: true
          });
        });
      });
    }
    return formattedTerms;
  } catch (error) {
    console.log('error', error);
  }
};

export const NestedEmptyState = ({ node, t }) => {
  return (<>
    <div className="tableFilterModal__suggestion-empty-item flex-v-center" data-test-id="cs-taxonomy-filter-empty">{t('RenderTaxonomy.taxonomy_empty') || 'Taxonomy is empty.'}</div>
  </>);
};

const RenderTaxonomy = ({
  fetchData,
  filterObject = {},
  updateMultipleValue,
  isFilterDropdownOpen,
  onClearFilter,
  searchInput = '',
  onClearBtnRef,
  handleSelectQuery,
  t

}: any) => {
  const fetchMoreRootData = async ({ skip, limit, searchInput }) => {
    try {
      if (searchInput) {
        const response = await fetchData.fetchTaxonomies({ skip, limit, searchInput });
        let formattedTerms = formatTaxonomyData(response.terms);
        return { data: formattedTerms, totalCounts: response.count };
      }

      const response = await fetchData.fetchTaxonomies({ skip, limit });

      const allTaxonomies = response.taxonomies.map((data) => ({
        name: data.name,
        uid: data.uid,
        taxonomy: true,
        termsCount: data.terms_count,
        childrenCount: data.terms_count
      }));

      //   const isBlankTaxonomySelected = filterObject.value.find((fi) => fi.value === '_blank');
      //   const blankTaxonomy = {
      //     name: 'Uncategorized Entries',
      //     uid: '_blank',
      //     type: 'blank',
      //     termsCount: 0,
      //     childrenCount: 0,
      //     checked: isBlankTaxonomySelected ? true : false
      //   };

      //   const isBlankTaxonomyPresent = allTaxonomies.find((taxonomy) => taxonomy.uid === '_blank');
      //  if(data?.children?.length){
      //     return { data: [...allTaxonomies] , totalCounts: !!response.count ? response.count + 1 : 1 };
      //  }

      return { data: [...allTaxonomies], totalCounts: !!response.count ? response.count : 0 };
    } catch (error) {
      console.log('RenderTaxonomy fetchMoreRootData ', error);
    }
  };

  const fetchMoreNestedData = async ({ skip, limit, node }) => {
    try {
      if (node.taxonomy) {
        const response = await fetchData.fetchTaxonomies({ skip, limit, taxonomyUid: node.uid });

        const allTerms = response.terms.map((data) => ({
          name: data.name,
          uid: data.uid,
          taxonomyUid: data.taxonomy_uid,
          term: true,
          childrenCount: data.children_count
        }));


        return { data: allTerms, totalCounts: response.count };
      }

      const response = await fetchData.fetchTaxonomies({
        skip,
        limit,
        termUid: node.uid,
        taxonomyUid: node.taxonomyUid
      });
      const allTerms = response.terms.map((data) => ({
        name: data.name,
        uid: data.uid,
        taxonomyUid: node.taxonomyUid,
        term: true,
        childrenCount: data.children_count
      }));

      return { data: allTerms, totalCounts: response.count };
    } catch (error) {
      console.log('fetchMoreRootData ~ error:', error);
    }
  };

  const onToggle = () => { };

  const NestedEmptyStateWithT = (props) => <NestedEmptyState {...props} t={t} />;

  return (
    <TreeView
      ref={onClearBtnRef}
      isFilterDropdownOpen={isFilterDropdownOpen}
      fetchMoreRootData={fetchMoreRootData}
      fetchMoreNestedData={fetchMoreNestedData}
      onToggle={onToggle}
      customDecorators={{
        Header: HeaderComponent,
        NestedEmptyState: NestedEmptyStateWithT
      }}
      nestedFolderLimit={30}
      limitForRoot={30}
      userSelections={{
        filterObject,
        updateMultipleValue,
        onClearFilter
      }}
      // scrollableTarget="scrollableDivTaxonomy"
      searchPlaceHolder={filterObject.placeHolder}
      searchInput={searchInput}
      type="taxonomy-advanced-search"
      autoFocus={typeof filterObject.autoFocus === 'undefined' ? true : filterObject.autoFocus}
      handleSelectQuery={handleSelectQuery}
      t={t}
    />
  );
};

export default RenderTaxonomy;
